import React from 'react';
import USP, { TrustpilotWidget } from '@ajat/design-system/ContentBlocks/USP';
import { ComponentPage, DemoCard } from '../../shared';

const TRUSTPILOT = {
  businessUnitId: '46905da900006400050004f8',
  locale: 'da-DK',
  reviewUrl: 'https://dk.trustpilot.com/review/cls.dk',
};

export const meta = {
  component: USP,
  componentName: 'USP',
  title: 'USP',
  group: 'Content Blocks',
  importPath: '@ajat/design-system/ContentBlocks/USP',
  description:
    'Horizontal selling-points bar with an optional Trustpilot widget. Icons are named keys, not nodes, so the copy stays data and the block can be driven straight from CMS content.',
  propSets: [
    {
      title: 'USP',
      component: USP,
      componentName: 'USP',
      rows: [
        ['items', 'array', '[]', '[{ icon, label }] — icon is a named key, not a node'],
        ['trustpilot', 'object', 'null', 'TrustpilotWidget props; omit it and no widget renders'],
        ['endContent', 'node', 'null', 'Extra content at the end of the bar'],
        ['width', "'full' | 'layout'", "'full'", "'full' = edge-to-edge gray bar; 'layout' = desktop box inside the layout gutters, bottom corners --radius-card (hangs under a boxed hero, Figma 8789:202173). Mobile is always full-bleed"],
        ['className', 'string', "''", 'Additional CSS class'],
      ],
    },
    {
      title: 'TrustpilotWidget',
      component: TrustpilotWidget,
      componentName: 'TrustpilotWidget',
      rows: [
        ['businessUnitId', 'string', '—', 'Trustpilot business unit id (required)'],
        ['locale', 'string', "'da-DK'", 'Widget locale'],
        ['templateId', 'string', "'5419b637fa0340045cd0c936'", 'Trustpilot template id'],
        ['theme', "'light' | 'dark'", "'light'", 'Widget theme'],
        ['height', 'string', "'24px'", 'Widget height'],
        ['width', 'string', "'100%'", 'Widget width'],
        ['reviewUrl', 'string', "'#'", 'Link to the review page'],
      ],
    },
  ],
  propsNote:
    'ABC-SE deliberately renders this without the Trustpilot widget — the id and URL in the code are CLS-DK placeholders, so only restore it with ABC\'s own business unit.',
  usage: [
    {
      title: 'On the CLS-DK landing',
      code: `import USP from '@ajat/design-system/ContentBlocks/USP';

<USP
  items={[
    { icon: 'fast-delivery', label: 'Gratis fragt' },
    { icon: 'size-guarantee', label: 'Personlig kontakt' },
    { icon: 'payment', label: 'Trykkeri i Danmark' },
  ]}
  trustpilot={{
    businessUnitId: '46905da900006400050004f8',
    locale: 'da-DK',
    reviewUrl: 'https://dk.trustpilot.com/review/cls.dk',
  }}
/>`,
    },
    {
      title: 'Without Trustpilot',
      code: `// ABC-SE ships the bar with no widget
<USP items={items} />`,
    },
  ],
};

export default function USPPage() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="As shipped on CLS-DK" hint="three points + Trustpilot" flush>
        <USP
          items={[
            { icon: 'fast-delivery', label: 'Gratis fragt' },
            { icon: 'size-guarantee', label: 'Personlig kontakt' },
            { icon: 'payment', label: 'Trykkeri i Danmark' },
          ]}
          trustpilot={TRUSTPILOT}
        />
      </DemoCard>

      <DemoCard title="Without Trustpilot" hint="how ABC-SE ships it" flush>
        <USP
          items={[
            { icon: 'fast-delivery', label: 'Fri frakt' },
            { icon: 'size-guarantee', label: 'Personlig kontakt' },
            { icon: 'payment', label: 'Trygg betalning' },
          ]}
        />
      </DemoCard>

      <DemoCard title="Trustpilot only" flush>
        <USP trustpilot={TRUSTPILOT} />
      </DemoCard>
    </ComponentPage>
  );
}
